module.exports = function (app) {
	'use strict';

	require('./add/add')(app);
	require('./find/find')(app);
	require('./enrollment')(app);
	require('./cancelCoverage')(app);
	require('./enrollmentsInProcess')(app);


	app.controller('pages.employee', ['$state', '$scope', 'sessionData', '$filter',  'modal',
		function ($state, $scope, sessionData, $filter, modal) {

			$scope.sidebar = {
				breadCrumb: {
					primary: {
						title: 'Enrollment'
					}
				},
				links: [
					{
						heading: 'Find Employee',
						label: 'Find Employee',
						state: 'employee.find',
						description: 'Find Employee Information'
					}, {
						heading: 'Add Employee',
						label: 'Add Employee',
						state: 'employee.add.subscriber',
						description: 'Add Employee Information'
					}, {
						heading: 'Enrollments in Process',
						label: 'Enrollments in Process',
						state: 'employee.enrollmentsInProcess',
						description: 'Check Enrollments In Process'
					}, {
						heading: 'USERRA Form',
						label: 'USERRA Form',
						state: 'employee.userraForm',
						description: 'Use the USERRA Form'
					}, {
						heading: 'Group Procedures for USERRA',
						label: 'Group Procedures for USERRA',
						state: 'employee.userraGroupProcedures',
						description: 'Read up on the USERRA Group Procedures'
					}, {
						heading: 'Tutorial - Enrollment',
						label: 'Tutorial - Enrollment',
						state: 'employee.tutorial',
						description: 'Tutorials on how to use Enrollment'
					}]
			};
		}
	]);


	return [
		{
			// Root state for all employee pages, FIND/ADD, etc as they are created, so that you can organize appropriately for the url.
			state: 'employee',
			url: '/manage-employees',
			// abstract: true,
			postPassword: true,
			views: {
				'body@': {
					template: bootstrap.templates['page-templates/hmhs/landing-page.html'],
					controller: 'pages.employee'
				}
			}
		},
		{
			state: 'employee.enrollment',
			url: '/enrollment',
			postPassword: true,
			views: {
				'dashboard@employee': {
					templateUrl: 'manage-employees/enrollment.employerTemplate.html/pages/employee/enrollment',
					controller: 'pages.employee.enrollment'
				},
				'enrollments-in-process@employee.enrollment': {
					templateUrl: 'manage-employees/enrollments-in-process.employerTemplate.html/pages/employee/enrollmentsInProcess',
					controller: 'pages.employee.enrollmentsInProcess'
				}
			}
		},
		{
			state: 'employee.enrollmentsInProcess',
			url: '/enrollments-in-process',
			views: {
				'dashboard@employee': {
					template: '<section class="epr-desktop epr-white-round" data-ui-view="content"></section>',
					controller: 'pages.employee.enrollmentsInProcess'
				},
				'content@employee.enrollmentsInProcess': {
					templateUrl: 'manage-employees/enrollments-in-process.employerTemplate.html/pages/employee/enrollmentsInProcess',
					controller: 'pages.employee.enrollmentsInProcess'
				}
			}
		},
		{
			state: 'employee.userraForm',
			url: '/userra-form',
			views: {
				'content@employee': {
					templateUrl: 'manage-employees/userra-form.employerTemplate.html/pages/employee/userraForm'
				}
			}
		},
		{
			state: 'employee.userraGroupProcedures',
			url: '/userra-group-procedures',
			views: {
				'content@employee': {
					templateUrl: 'manage-employees/userra-group-procedures.employerTemplate.html/pages/employee/userraGroupProcedures'
				}
			}
		},
		{
			state: 'employee.tutorial',
			url: '/tutorial',
			views: { 
				'content@employee': {
					templateUrl: 'manage-employees/tutorial.employerTemplate.html/pages/employee/tutorial'
				}
			}
		},
		{
			state: 'employee.cancelCoverage',
			url: '/cancel-coverage',
			params: {umi:''},
			views: {
				'dashboard@employee': {
					template: '<section class="epr-desktop epr-white-round" data-ui-view="content"></section>'
				},
				'content@employee.cancelCoverage': {
					templateUrl: 'manage-employees/cancel-coverage.employerTemplate.html/pages/employee/cancelCoverage',
					controller: 'pages.employee.cancelCoverage'
				}
			}
		}
	];
};
